import './Button.css';
import { useSelector } from 'react-redux';
function Button({text, classes,action,hotkey=null,activeEl=null, disabled=false}) {
    const { gamePage } = useSelector(state=>state.game);
    return (
        <div className="button-container">
        <button 
        className= {classes}
        onClick={()=>!disabled && action()}
        disabled={disabled}>            
            {text}
        </button>
            {hotkey != null ? 
            <small>
                {gamePage === true ? <span className="button-hotkey">Disengage + </span>: null}
                Press <span className="button-hotkey">                
                {hotkey}
                </span>
                </small> 
            : null }        
        </div>
    );
}

export default Button;